import { Component, OnInit } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { UserService } from "src/_services/user.service";
import { Router } from "@angular/router";
import { Users } from "src/_models/user";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-create-users",
  templateUrl: "./create-users.component.html",
  styleUrls: ["./create-users.component.scss"],
})
export class CreateUsersComponent implements OnInit {
  private role: string[];
  private status: string[];
  private user: Users;
  operatorData = [];
  filteredOperatorData = [];
  operatorSearchText = "";
  operators = new FormControl("");
  invoiceControl = new FormControl(false);
  twoFaControl = new FormControl(false);

  constructor(
    private appService: AppService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getRoleType();
    this.getOperatorData();
    this.role = ["OperatorAdmin", "SAPAdmin"];
    this.status = ["ACTIVE", "BLOCKED"];
    this.user = new Users({
      user_id: "",
      role: this.role[0],
      user_name: "",
      status: this.status[0],
      password: "",
      invoice: this.invoiceControl.value,
      "2fa": this.twoFaControl.value,
    });
  }
  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators;
          this.filterOperators();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  getRoleType() {
    try {
      this.userService.getRoleType().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.role = res.roles;
          this.role = this.role.concat(["GroupAdmin","InvoiceAdmin"]);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  redirectAddOperatorPage() {
    this.router.navigate(["administration/users"]);
  }

  onSelectedRole(val) {
    this.user.role = val;
    this.operators.setValue("");
    this.operatorSearchText = "";
    this.filterOperators();
  }

  filterOperators() {
    const q = (this.operatorSearchText || "").toLowerCase().trim();
    if (!q) {
      this.filteredOperatorData = this.operatorData.slice();
      return;
    }
    this.filteredOperatorData = this.operatorData.filter((o) =>
      String(o.operator_id).toLowerCase().includes(q)
    );
  }

  onOperatorSelectOpened(open: boolean) {
    if (open) {
      this.operatorSearchText = "";
      this.filterOperators();
    }
  }

  get isValid() {
    if (this.user.user_id !== "" && this.user.user_id !== null && this.user.user_name !== "" && 
    this.user.user_name !== null && this.user.password !== "" && this.user.password !== null &&
    this.user.role !== "" && this.user.role !== null && this.operators.value !== "" &&
    this.operators.value !== null) {
      return false;
    }
    return true;
  }

  onFormSubmit({ value, valid }: { value: Users; valid: boolean }) {
    // this.user = value;
    console.log(this.user);
    if (this.user.role === "GroupAdmin" || this.user.role === "GroupUser" || this.user.role === "MetricsAdmin") {
      this.user.operators = this.operators.value;
    }else{
      this.user.operator_id = this.operators.value;
    }
    this.user.invoice = this.invoiceControl.value;
    this.user["2fa"] = this.twoFaControl.value;
    try {
      this.appService.addUsers(this.user).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("User added successfully");
          this.router.navigateByUrl("administration/users");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {
      console.log("err", err);
    }
  }
}
